<script setup>
import { useOnline } from '@vueuse/core'

// Avviso globale: l'app vive di risultati real-time, quindi offline i dati
// mostrati (ultimo calendario/classifica in cache SW) possono essere vecchi.
const online = useOnline()
</script>

<template>
  <div
    v-if="!online"
    role="status"
    aria-live="polite"
    class="fixed inset-x-0 top-0 z-50 bg-warning px-4 py-1.5 text-center text-sm font-medium text-warning-content shadow"
  >
    Sei offline: dati non aggiornati
  </div>
</template>
